<template>
  <div style="height: 100%; display: flex; flex-direction: column">
    <div style="font-size: 12px; font-weight: 700; margin-bottom: 10px">
      {{ previewData.name }}
    </div>
    <div
      style="height: calc(100% - 27px); display: flex; flex-direction: column"
    >
      <el-table
        :data="records"
        style="width: 100%"
        border
        height="100%"
        :header-cell-style="headerCellStyle"
        :cell-style="cellStyle"
      >
        <el-table-column
          :prop="field.code"
          :label="field.name"
          v-for="field in previewData.fields"
          :key="field.code"
          :width="
            ['Created', 'Updated', 'DateTime'].includes(field.code)
              ? '180px'
              : previewData.fields.length < 5
              ? 'auto'
              : flexColumnWidth(item.name, records, item.code)
          "
        >
        </el-table-column>
      </el-table>
      <div
        style="
          padding: 5px;
          width: 100%;
          display: flex;
          justify-content: flex-end;
          align-items: center;
        "
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[20, 50, 100]"
          :page-size="20"
          layout="total, sizes, prev, pager, next"
          :total="previewData.data.total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  flexColumnWidth,
  cellStyle,
  headerCellStyle,
} from "@/utils/CustomUtil.js";
import { getTableData, getFormListPreview } from "@/api/design";
export default {
  name: "DataTable",
  props: {
    previewData: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    records() {
      console.log(this.data);
      if (this.data.length > 0) {
        return this.data;
      }
      console.log(this.previewData, "123");
      return this.previewData.data.records;
    },
  },
  data() {
    return {
      queryData: {
        pageNumber: 1,
        pageSize: 20,
      },
      data: [],
    };
  },
  methods: {
    // 设置单元格样式
    cellStyle,
    //自适应宽度
    flexColumnWidth,
    // 设置表头单元格样式
    headerCellStyle,
    handleSizeChange(val) {
      this.queryData.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.queryData.pageNumber = val;
      this.getList();
    },
    async getList() {
      if (this.previewData.id) {
        const { data } = await getTableData({
          ...this.previewData,
          ...this.queryData,
        });
        console.log(data, "11");
        this.data = data.data.records;
      } else {
        const { data } = await getFormListPreview({
          ...this.previewData,
          ...this.queryData,
        });
        console.log(data, "11");
        this.data = data.data.records;
      }
    },
  },
};
</script>

<style scoped lang="less">
// /deep/ .el-table__body-wrapper {
//   height: 100% !important;
// }

/deep/ .cell {
  font-size: 13px;
  color: #1f1f1f;
  font-weight: 700;
}

/deep/ .el-table .el-table__cell {
  padding: 5px 0 !important;
}
</style>